module.exports = __webpack_public_path__ + "static/img/chuhuozhong.cbe7dfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chuhuozhong.png
// module id = lJJJ
// module chunks = 128